export const stackedBar = {
  chart: {
    type: 'bar'
  },
  labels: {
    useHTML: true,
  },
  title: {
    text: ''
  },
  xAxis: {
    labels: {
      useHTML: true
    }
  },
  yAxis: {
    min: 0,
    max: 100,
    title: {
      text: ''
    },
    labels: {
      useHTML: true,
      formatter: function () {
        return `${this.value}%`;
      }
    },
    tickInterval: 25
  },
  legend: {
    enabled: false
  },
  plotOptions: {
    series: {
      stacking: 'normal',
      dataLabels: {
        enabled: false,
        formatter: function() {
          const voteLabel = this.point.voteCount === 1 ? 'vote' : 'votes';
          if(this.key === 'score'){
            return `<span>\u00A0\u00A0\u00A0${this.point.voteCount} ${voteLabel}</span>`;
          }
        },
        align: 'left',
        verticalAlign: 'bottom',
        style: {
          fontFamily: 'Open sans',
          fontWeight: 'normal',
          fontSize: '1.5rem'
        }
      },
      states: {
        hover: {
          enabled: false
        }
      }
    }
  },
  tooltip: {
    shared: false,
    useHTML: true,
    formatter: function() {
      const voteLabel = this.point.voteCount === 1 ? 'vote' : 'votes';
      if (this.series.name === 'Votes'){
        return `<span>${this.point.choice}</span>
                <br/>
                <span>${Math.round(this.point.percentage)}%</span>
                <span>\u00A0(${this.point.voteCount} ${voteLabel})</span>`
      } else {
        return false;
      }
    },
    shape: 'square'
  }
}
